import { FormattedMessage } from 'react-intl';

import { StackedCards } from '@sorare/core/src/atoms/icons/StackedCards';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

export const TokenListingsCount = ({ count }: { count: number }) => {
  return (
    <Horizontal as="span" gap={1}>
      <StackedCards />
      <FormattedMessage
        defaultMessage="{count} {count, plural, one {listing} other {listings}}"
        values={{ count }}
      />
    </Horizontal>
  );
};
